<template>
    <div class="box">
          <div class="contaner-title"><span>个人中心</span> <span>/ 消息列表</span></div>
                <div class="hr"></div>
        <div class="contaner">
            <ul>
                <li :class="item.IsRead == 1 ? '' : 'unread'" v-for="(item,index) in MsgList">{{item.Content}}<span v-if="item.Url">,<a :href="item.Url">点击查看</a></span><span style="float:right;">{{item.AddTime}}</span></li>
            </ul>
        
       </div>
           <div style="text-align:right;margin-top:20px;">
                <Page :total="Count" @on-change="changePage" />
            </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            UserInfo: [],
            Count: 0,
            Page: 1,
            PageSize: 10,
            MsgList:[],//消息列表
            IDList:[],//当前页ID列表
        }
    },
    mounted() {
        this.UserInfo = JSON.parse(this.$getLS('AdminInfo'));
        this.getMsgList();
    },
    methods:{
        //跳转到某页
        changePage(val){
            this.Page = val;
            this.getMsgList();
        },
        //获取消息列表
        getMsgList(){
            let params = {
                'MemberID': this.UserInfo.ID,
                'page': this.Page,
                'pageSize': this.PageSize,
            }
            this.$post('api/manage.PersonCenter/getMsgList', params).then(res=>{
                if(res.code==1){
                    let MsgList = res.data.data;
                    for (let i = 0; i < MsgList.length; i++) {
                        if (MsgList[i]['IsRead'] == 0) {
                            this.IDList.push(MsgList[i]['ID']);
                        }
                    }
                    this.MsgList = MsgList;
                    this.Count = res.data.all_num;
                    if (this.IDList.length > 0) {
                        //更新消息状态
                        let params2 = {
                            'IDList': this.IDList
                        }
                        this.$post('api/manage.PersonCenter/updateMsgList', params2).then(res=>{
                            console.log(res.msg);
                        })
                    }
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.box{
 padding:30px;
 box-sizing: border-box;
 height: calc(~"100% - 64px");
 .contaner{
    background-color: #fff;
    margin-top: 30px;
    box-shadow: 0px 3px 5px #D9DDE3;
    padding:15px;
    // height: calc(~"100% - 52px");
    ul{
        li{
            padding-left: 30px;
            height: 50px;
            line-height: 50px;
            border-bottom:1px solid #EEEEEE;
            position: relative;
        }
        .unread{
            :after{
                content:'';
                width:6px;
                height: 6px;
                background-color: red;
                position: absolute;
                left: 12px;
                top:22px;
                border-radius: 50%;
            }
        }
    }
 }
  
}

</style>


// WEBPACK FOOTER //
// src/view/HomePage/Message.vue